/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-03, 10:04:01
 * Author: Sebastian Drzewicki <sebastian.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-03-05, 10:56:11
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */
import Vue from 'vue';
import sAuth from '@/services/sAuth';
// /// AXIOS CONFIG /////////////////////////////////////////////////////////////
import axios from 'axios';

const authInterceptor = (config) => {
  // eslint-disable-next-line no-use-before-define
  const jwtToken = tokenStorage.getItem('token');
  let _config = config;
  if (jwtToken) _config.headers.Authorization = `Bearer ${jwtToken}`;
  return _config;
};

const errorHandlerInterceptor = (error) => {
  const errorStatusMap = {
    404: 'Błąd',
    429: 'Za dużo prób. Prosimy spróbować ponownie za chwilę',
    503: 'Błąd serwera. Prosimy spróbować ponownie',
    504: 'Chwilowo nasze zasoby nie odpowiadają. Prosimy spróbować ponownie za chwilę',
    500: 'Chwilowy błąd serwera. Prosimy spróbować ponownie',
  };

  // nie pokazuj notyfikacji dla odpowiedzi z HTTP ze statusem 406
  if (error.response ? error.response.status !== 406 && error.response.status !== 403 : true) {
    const timeoutMessage = 'Przekroczono czas oczekiwania, proszę spróbować jeszcze raz';
    (new Vue())
      .$toaster.error(error.response ? errorStatusMap[error.response.status] : timeoutMessage);
  } else if (error.response && error.response.status === 403) {
    sAuth.removeToken();
    window.location.reload();
    (new Vue()).$toaster.error('Ze względów bezpieczeństwa, po 60 minutach nastąpiło automatyczne wylogowanie.');
  }
  return Promise.reject(error);
};
/* eslint-disable */
const api = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Brand': window.location.host,
  },
  timeout: 20000,
  withCredentials: true,
});

api.interceptors.request.use(authInterceptor, errorHandlerInterceptor);
api.interceptors.response.use(config => config, errorHandlerInterceptor);

// /// EXPORTS CONFIG ///////////////////////////////////////////////////////////
export const API_URL = process.env.API_URL;
export const tokenStorage = localStorage;
export const API = api;



// WEBPACK FOOTER //
// ./src/config.js